export default "__VITE_ASSET__B97x4PiV__"